export class NewPassword {
    passwordResetToken?: string;
    password?: string;
}
